// Compact period dropdown for a dashboard chart card header.
// Usage: <ChartPeriodFilter value={period} onChange={(p) => ...} />

import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { CHART_PERIOD_OPTIONS } from "./chartPeriodUtils";

const ChartPeriodFilter = ({ value, onChange }) => (
  <Select
    size="small"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={{ minWidth: 140, fontSize: 13 }}
  >
    {CHART_PERIOD_OPTIONS.map((opt) => (
      <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: 13 }}>
        {opt.label}
      </MenuItem>
    ))}
  </Select>
);

export default ChartPeriodFilter;
